import { render, staticRenderFns } from "./BatchProblemDiscrepancy.vue?vue&type=template&id=11620272&"
import script from "./BatchProblemDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./BatchProblemDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports